const projectData = [
  {
    id: 12012,
    name: "BIZ360",
    description:
      "An Enterprise Resource Planning app for managing business operations, resources, and workflows at scale.",
    image: "/biz360.png",
    technologies: ["React", "TypeScript", "Bootstrap", "Redux", "TanStack Query"],
  },
  {
    id: 15513,
    name: "Partner Portal",
    description:
      "A web application to manage engagement between an NGO and its partners, track activities and deliverables.",
    image: "/pportal.png",
    technologies: ["JavaScript", "jQuery", "Bootstrap", "CSS", "Redux"],
  },
  {
    id: 8801002,
    name: "MoneyFloat",
    description:
      "Marketing website for MoneyFloat — a cash and float tracking tool built for mobile money agents in Ghana. Features session management, real-time balance reconciliation, PDF reports, and multi-agent support.",
    image: "/moneyfloatweb.png",
    technologies: ["React", "TypeScript", "Vite", "React Router"],
  },
  {
    id: 8801001,
    name: "MoVaultX",
    description:
      "Marketing website for MoVaultX — a mobile savings app built for Ghana. Highlights savings dashboards, instant deposits, admin-approved payouts, group savings, and biometric login.",
    image: "/movaultxweb.png",
    technologies: ["React", "TypeScript", "Vite", "Tailwind CSS", "React Router"],
  },
  {
    id: 8801003,
    name: "ONE ONE INC",
    description:
      "A luxury African streetwear e-commerce platform with a curated shop, community features, admin dashboard, and a full checkout flow powered by Firebase.",
    image: "/oneonepic.png",
    technologies: ["Next.js", "Tailwind CSS", "Redux", "Firebase", "Framer Motion", "Zod"],
  },
  {
    id: 8801004,
    name: "JSKLR",
    description:
      "A multi-tenant SaaS booking platform — each business gets its own branded booking page at a subdomain, with staff management, service scheduling, and direct Stripe-powered payments. Built as a pnpm monorepo.",
    image: "/jsklrweb.png",
    technologies: [
      "Next.js",
      "TypeScript",
      "Fastify",
      "Node.js",
      "PostgreSQL",
      "Redis",
      "Stripe",
      "Tailwind CSS",
    ],
  },
  {
    id: 125145,
    name: "RxPMS",
    description:
      "A pharmacy management web app for handling inventories, employee sales, payments, and stock control.",
    image: "/rxpms.png",
    technologies: ["Next.js", "Tailwind CSS", "TanStack Query", "Redux"],
  },
  {
    id: 1005145,
    name: "Luxe Valet Ghana",
    description:
      "A modern web app for premium valet parking services and online booking management in Ghana.",
    image: "/luxevalet.png",
    technologies: ["React", "Tailwind CSS", "Redux"],
  },
  {
    id: 7554840,
    name: "Tribals",
    description:
      "A creative-sharing platform that empowers artists and creatives to publish and showcase their work to the world.",
    image: "/tribals.png",
    livedemo: "https://tribalz.netlify.app/",
    github: "https://github.com/aneallaryea100/nextui",
    technologies: ["Next.js", "Tailwind CSS", "Redux"],
  },
  
  
];

export default projectData;
